import { TableHead, TableRow, withStyles } from '@material-ui/core';
import { StyledTableHeaderCell } from '.';

const styles = (theme) => ({
  tableHead: {
    backgroundColor: theme.printTableHead
  },
  tableRow: {
    pageBreakInside: 'avoid',
    height: 'auto'
  }
});

const TableHeader = ({ classes, columns }) => (
  <TableHead className={classes.tableHead}>
    <TableRow className={classes.tableRow}>
      {columns?.map((col, index) => (
        <StyledTableHeaderCell key={index} style={{ width: col.printColWidth || 'auto' }}>
          {col.headerName}
        </StyledTableHeaderCell>
      ))}
    </TableRow>
  </TableHead>
);

export default withStyles(styles)(TableHeader);
